import { useState, useCallback } from 'react';
import {
    ChoiceList,
    ResourceList,
    Filters,
    // Icon,
    Badge,
    Thumbnail,
    Button,

} from '@shopify/polaris';
import { NoteIcon } from "@shopify/polaris-icons";
import './index.css';
import Language from '../../i18n/Language';
import { useEffect } from 'react';
import CircularViewGauge from '../CircularViewGauge';
const t = Language;

const SearchFilterList = (props) => {
    const {
        pagetype,
        tableDataList,
        tableListLoading,
        selectItem,
        issueListData,
        // selectItemTagNums,
        selectItemTag,
        issueValueSel,
        queryVal,
        scoreListData,
        seoScoreSel,
        focusKeywordListData,
        focusKeywordSel,
        productStatusData,
        onpage_ProductStatus,
        blogVisibleData,
        onpage_BlogVisible,
        // FAQ / How-To schema + Product Tag 筛选 (与列表页 TableFilters 对齐)
        faqSchemaSel,
        howtoSchemaSel,
        productTagSel,
        productTagListData,

        clearFilterTag,
        /** 一次性清空所有筛选并只请求一次列表（由父组件 patch + getPageList） */
        onFiltersClearAll,
        setSearchQuery,
        handleChangeItemObj,
        setIssueTypeChange,
        total,
        // pageLoading,
        // openAltOperaData,
        setSeoScoreChange,
        setFocusKeywordChange,
        setOnpageProductStatusChange,
        setOnpageBlogVisibleChange,
        setFaqSchemaChange,
        setHowtoSchemaChange,
        setProductTagChange,
    } = props;

    // FAQ / How-To schema 选项 (与列表页 TableFilters 对齐: Has / No)
    const faqSchemaChoices = [
        { label: t("Has FAQ schema"), value: 1 },
        { label: t("No FAQ schema"), value: 0 },
    ];
    const howtoSchemaChoices = [
        { label: t("Has Howto schema"), value: 1 },
        { label: t("No Howto schema"), value: 0 },
    ];
    // Product Tag 候选 (标签原文即值, 后端 productTags[] 精确匹配)
    const productTagChoices = (productTagListData || []).map((tag) => ({ label: tag, value: tag }));

    const [queryValue, setQueryValue] = useState('');   // 搜索值
    const [tableData, setTableData] = useState([]); // 列表
    const [selectId, setSelectId] = useState([]);   // 当前选中id
    const [issueType, setIssueType] = useState([]); // 过滤条件
    const [seoScore, setSeoScore] = useState([]); // 过滤条件
    const [focusKeyword, setFocusKeyword] = useState([]); // 过滤条件
    const [faqSchema, setFaqSchema] = useState([]); // FAQ schema 过滤条件
    const [howtoSchema, setHowtoSchema] = useState([]); // How-To schema 过滤条件
    const [productTag, setProductTag] = useState([]); // Product Tag 过滤条件
    // Product Tag 分批渲染: 默认展示 50 个, 点击"加载更多"每次追加 50 个
    const PRODUCT_TAG_PAGE_SIZE = 50;
    const [productTagVisibleCount, setProductTagVisibleCount] = useState(PRODUCT_TAG_PAGE_SIZE);
    const handleLoadMoreProductTag = () => {
        setProductTagVisibleCount((c) => c + PRODUCT_TAG_PAGE_SIZE);
    };


    // 搜素
    const handleFiltersQueryChange = (value) => {
        setQueryValue(value);
        setSearchQuery(value);
    };
    // 去除搜索
    const handleQueryValueRemove = () => {
        setQueryValue('');
        setSearchQuery('');
    };

    const handleChangeItem = (obj) => {
        handleChangeItemObj(obj);
    }

    // Onpage 产品状态
    const [onpageProductStatus, setOnpageProductStatus] = useState([]);
    const handleOnpageProductStatusChange = (value) => {
        setOnpageProductStatus(value)
        setOnpageProductStatusChange(value)
    }

    // Onpage 博客可见状态
    const [blogVisibleStatus, setBlogVisibleStatus] = useState([]);
    const handleBlogVisibleChange = (value) => {
        setBlogVisibleStatus(value)
        setOnpageBlogVisibleChange(value)
    }

    // Onpage 产品状态
    const handleOnpageProductStatusRemove = () => {
        setOnpageProductStatus([]);
        setOnpageProductStatusChange(-1)
    }

    // Onpage 博客可见状态
    const handleBlogVisibleRemove = () => {
        setBlogVisibleStatus([]);
        setOnpageBlogVisibleChange(-1)
    }

    // 选择对应条件过滤
    const handleIssueTypeChange = (value) => {
        setIssueType(value)
        setIssueTypeChange(value)
    };
    // 单独删除对应过滤条件
    const handleIssueTypeRemove = () => {
        setIssueType([])
        setIssueTypeChange(-1)
    };
    // 选中分数条件
    const handleSEOScoreChange = (val) => {
        setSeoScore(val);
        setSeoScoreChange(val);
    };
    const handleSEOScoreRemove = () => {
        setSeoScore([]);
        setSeoScoreChange(-1);
    };
    // 选择关键词条件
    const handleFocusKeywordChange = (val) => {
        setFocusKeyword(val);
        setFocusKeywordChange(val);
    };
    const handleFocusKeywordRemove = () => {
        setFocusKeyword([]);
        setFocusKeywordChange(-1);
    };
    // FAQ schema 筛选
    const handleFaqSchemaChange = (value) => {
        setFaqSchema(value);
        if (setFaqSchemaChange) setFaqSchemaChange(value);
    };
    const handleFaqSchemaRemove = () => {
        setFaqSchema([]);
        if (setFaqSchemaChange) setFaqSchemaChange(-1);
    };
    // How-To schema 筛选
    const handleHowtoSchemaChange = (value) => {
        setHowtoSchema(value);
        if (setHowtoSchemaChange) setHowtoSchemaChange(value);
    };
    const handleHowtoSchemaRemove = () => {
        setHowtoSchema([]);
        if (setHowtoSchemaChange) setHowtoSchemaChange(-1);
    };
    // Product Tag 多选筛选
    const handleProductTagChange = (value) => {
        setProductTag(value);
        if (setProductTagChange) setProductTagChange(value);
    };
    const handleProductTagRemove = () => {
        setProductTag([]);
        if (setProductTagChange) setProductTagChange(-1);
    };

    // 产品状态筛选
    const productStatusFilters = pagetype === 'product' ? [
        {
            key: 'Statuses',
            label: t("Product Status"),
            filter: (
                <ChoiceList
                    title={t("Product Status")}
                    titleHidden
                    choices={productStatusData}
                    selected={onpageProductStatus || []}
                    onChange={handleOnpageProductStatusChange}
                    allowMultiple
                />
            ),
            shortcut: true,
            pinned: true,
        }
    ] : [];
    // Onpage 博客可见状态
    const blogVisibleFilters = pagetype === 'blog' ? [
        {
            key: 'Visibility',
            label: t("Visibility"),
            filter: (
                <ChoiceList
                    title={t("Visibility")}
                    titleHidden
                    choices={blogVisibleData}
                    selected={blogVisibleStatus || []}
                    onChange={handleBlogVisibleChange}
                    allowMultiple={false}
                />
            ),
            shortcut: true,
            pinned: true,
        }
    ] : [];
    // 公共筛选
    const publicFilters = [
        {
            key: 'issueType',
            label: t("Issue Category"),
            filter: (
                <ChoiceList
                    title={t("Issue Category")}
                    titleHidden
                    choices={issueListData}
                    selected={issueType || []}
                    onChange={handleIssueTypeChange}
                    allowMultiple={false}
                />
            ),
            shortcut: true,
            pinned: true,
        },
        {
            key: 'seoScore',
            label: t("SEO Score"),
            filter: (
                <ChoiceList
                    title={t("SEO Score")}
                    titleHidden
                    choices={scoreListData}
                    selected={seoScore || []}
                    onChange={handleSEOScoreChange}
                    allowMultiple
                />
            ),
            shortcut: true,
            pinned: true,
        },
        {
            key: 'focusKeyword',
            label: t("Primary keyword"),
            filter: (
                <ChoiceList
                    title={t("Primary keyword")}
                    titleHidden
                    choices={focusKeywordListData}
                    selected={focusKeyword || []}
                    onChange={handleFocusKeywordChange}
                    allowMultiple={false}
                />
            ),
            shortcut: true,
            pinned: true,
        },
        // FAQ schema 筛选 (所有页面类型均可用)
        {
            key: 'faqSchema',
            label: t("FAQ schema"),
            filter: (
                <ChoiceList
                    title={t("FAQ schema")}
                    titleHidden
                    choices={faqSchemaChoices}
                    selected={faqSchema || []}
                    onChange={handleFaqSchemaChange}
                />
            ),
            shortcut: true,
            pinned: true,
        }
    ]

    // How-To schema 筛选 (仅 Blog / Other Pages 可用)
    const howtoSchemaFilter = ['blog', 'otherpage'].includes(pagetype) ? [
        {
            key: 'howtoSchema',
            label: t("Howto schema"),
            filter: (
                <ChoiceList
                    title={t("Howto schema")}
                    titleHidden
                    choices={howtoSchemaChoices}
                    selected={howtoSchema || []}
                    onChange={handleHowtoSchemaChange}
                />
            ),
            shortcut: true,
            pinned: true,
        }
    ] : []

    // Product Tag 多选筛选 (仅 Products, 放在筛选列表最下面)
    // 分批渲染: 默认 50 个, 点击"加载更多"追加; 已选中的标签始终保留在可选项中, 避免被截断
    const visibleProductTagChoices = productTagChoices.slice(0, productTagVisibleCount);
    const selectedProductTagChoices = productTagChoices.filter(
        (c) => (productTag || []).includes(c.value) && !visibleProductTagChoices.some((v) => v.value === c.value)
    );
    const renderedProductTagChoices = [...visibleProductTagChoices, ...selectedProductTagChoices];
    const hasMoreProductTag = productTagChoices.length > renderedProductTagChoices.length;
    const productTagFilter = (pagetype === 'product' && productTagChoices.length > 0) ? [{
        key: 'productTag',
        label: t("Product Tag"),
        filter: (
            <div>
                <ChoiceList
                    title={t("Product Tag")}
                    titleHidden
                    choices={renderedProductTagChoices}
                    selected={productTag || []}
                    onChange={handleProductTagChange}
                    allowMultiple
                />
                {hasMoreProductTag && (
                    <div style={{ marginTop: 8 }}>
                        <Button variant="plain" onClick={handleLoadMoreProductTag}>
                            {t("Load more")}
                        </Button>
                    </div>
                )}
            </div>
        ),
        shortcut: true,
        pinned: true,
    }] : [];

    // 总筛选
    const filters = [
        ...productStatusFilters,
        ...blogVisibleFilters,
        ...publicFilters,
        ...howtoSchemaFilter,
        ...productTagFilter,
    ];

    const appliedFilters = [];
    if (onpageProductStatus && !isEmpty(onpageProductStatus)) {
        const key = 'Statuses';
        appliedFilters.push({
            key,
            label: disambiguateLabel(key, onpageProductStatus),
            onRemove: handleOnpageProductStatusRemove,
        });
    }
    if (blogVisibleStatus && !isEmpty(blogVisibleStatus)) {
        const key = 'Visibility';
        appliedFilters.push({
            key,
            label: disambiguateLabel(key, blogVisibleStatus),
            onRemove: handleBlogVisibleRemove,
        });
    }
    if (issueType && !isEmpty(issueType)) {
        const key = 'issueType';
        appliedFilters.push({
            key,
            label: disambiguateLabel(key, issueType),
            onRemove: handleIssueTypeRemove,
        });
    }
    if (seoScore && !isEmpty(seoScore)) {
        const key = 'seoScore';
        appliedFilters.push({
            key,
            label: disambiguateLabel(key, seoScore),
            onRemove: handleSEOScoreRemove,
        });
    }
    if (focusKeyword && !isEmpty(focusKeyword)) {
        const key = 'focusKeyword';
        appliedFilters.push({
            key,
            label: disambiguateLabel(key, focusKeyword),
            onRemove: handleFocusKeywordRemove,
        });
    }
    if (faqSchema && !isEmpty(faqSchema)) {
        const key = 'faqSchema';
        appliedFilters.push({
            key,
            label: disambiguateLabel(key, faqSchema),
            onRemove: handleFaqSchemaRemove,
        });
    }
    if (howtoSchema && !isEmpty(howtoSchema)) {
        const key = 'howtoSchema';
        appliedFilters.push({
            key,
            label: disambiguateLabel(key, howtoSchema),
            onRemove: handleHowtoSchemaRemove,
        });
    }
    if (productTag && !isEmpty(productTag)) {
        const key = 'productTag';
        appliedFilters.push({
            key,
            label: disambiguateLabel(key, productTag),
            onRemove: handleProductTagRemove,
        });
    }

    // 清空过滤（优先走父级单次请求，避免每个条件各触发一次 getPageList）
    const handleFiltersClearAll = useCallback(() => {
        setQueryValue('');
        setIssueType([]);
        setSeoScore([]);
        setFocusKeyword([]);
        setOnpageProductStatus([]);
        setBlogVisibleStatus([]);
        setFaqSchema([]);
        setHowtoSchema([]);
        setProductTag([]);
        if (typeof onFiltersClearAll === 'function') {
            onFiltersClearAll();
            return;
        }
        // handleQueryValueRemove();
        // handleIssueTypeRemove();
        // handleSEOScoreRemove();
        // handleFocusKeywordRemove();
        // handleOnpageProductStatusRemove();
        // handleBlogVisibleRemove();
    }, [
        onFiltersClearAll,
        // handleQueryValueRemove,
        // handleIssueTypeRemove,
        // handleSEOScoreRemove,
        // handleFocusKeywordRemove,
        // handleOnpageProductStatusRemove,
        // handleBlogVisibleRemove,
    ]);

    useEffect(() => {
        setSelectId(selectItem);
        setTableData(tableDataList);
        if (!Boolean(issueValueSel) || issueValueSel === -1) {
            setIssueType(undefined);
        } else {
            setIssueType([issueValueSel]);
        }
    }, [tableDataList, selectItem, issueValueSel])


    // Onpage 产品状态
    useEffect(() => {
        if (onpage_ProductStatus && !isEmpty(onpage_ProductStatus)) {
            setOnpageProductStatus(onpage_ProductStatus === -1 ? [] : onpage_ProductStatus);
        }
    }, [onpage_ProductStatus])

    // Onpage 博客可见状态
    useEffect(() => {
        if (onpage_BlogVisible && !isEmpty(onpage_BlogVisible)) {
            setBlogVisibleStatus(onpage_BlogVisible === -1 ? [] : onpage_BlogVisible);
        }
    }, [onpage_BlogVisible])

    useEffect(() => {
        if (!Boolean(seoScoreSel) || seoScoreSel === -1) {
            setSeoScore(undefined);
        } else {
            const issuesMap = {
                'Well Done': 0,
                'Need Improve': 1,
                'Important Issued': 2
            };
            let type = seoScoreSel.map(n => issuesMap[n]);
            setSeoScore(type);
        }
    }, [seoScoreSel])

    useEffect(() => {
        if (Boolean(focusKeywordSel === -1)) {
            setFocusKeyword(undefined);
        } else {
            setFocusKeyword(focusKeywordSel);
        }
    }, [focusKeywordSel])

    // 外部传入 FAQ schema 筛选预选值 (从列表页带入 / 父级同步)
    useEffect(() => {
        if (faqSchemaSel === undefined || faqSchemaSel === null || faqSchemaSel === -1 || faqSchemaSel === '') {
            setFaqSchema([]);
        } else {
            setFaqSchema(Array.isArray(faqSchemaSel) ? faqSchemaSel : [faqSchemaSel]);
        }
    }, [faqSchemaSel])

    // 外部传入 How-To schema 筛选预选值
    useEffect(() => {
        if (howtoSchemaSel === undefined || howtoSchemaSel === null || howtoSchemaSel === -1 || howtoSchemaSel === '') {
            setHowtoSchema([]);
        } else {
            setHowtoSchema(Array.isArray(howtoSchemaSel) ? howtoSchemaSel : [howtoSchemaSel]);
        }
    }, [howtoSchemaSel])

    // 外部传入 Product Tag 筛选预选值
    useEffect(() => {
        if (productTagSel === undefined || productTagSel === null || productTagSel === -1 || productTagSel === '') {
            setProductTag([]);
        } else {
            setProductTag(Array.isArray(productTagSel) ? productTagSel : [productTagSel]);
        }
    }, [productTagSel])

    // 标签列表变化时, 重置分批渲染数量为初始 50
    useEffect(() => {
        setProductTagVisibleCount(PRODUCT_TAG_PAGE_SIZE);
    }, [productTagListData])


    useEffect(() => {
        setQueryValue(queryVal);
    }, [queryVal])

    return (
        <ResourceList
            resourceName={{
                singular: t("data"),
                plural: t("datas")
            }}
            filterControl={<div className='search_input' id={`${pagetype}_filter`} key={`${pagetype}_filter_key`}>
                <>
                    {/* <Icon source={SearchMajor} tone='base' /> */}
                    <Filters
                        queryValue={queryValue}
                        filters={filters}
                        appliedFilters={appliedFilters}
                        onQueryChange={handleFiltersQueryChange}
                        onQueryClear={handleQueryValueRemove}
                        onClearAll={handleFiltersClearAll}
                        queryPlaceholder={t("Search in all")}
                        loading={tableListLoading}
                    />
                    {/* {
                        Boolean(queryValue) ? <div onClick={handleQueryValueRemove} className={`clear_icon ${window.shopify ? 'embedClear' : ''}`}><Icon source={CircleCancelMajor} tone='base' /></div> : null
                    } */}
                </>
                {
                    Boolean(selectItemTag) && <span className="Polaris-Tag Polaris-Tag--removable" style={{ margin: '0.5rem' }}>
                        <span title={`${selectItemTag}: ${total}`} className="Polaris-Tag__TagText">{selectItemTag}: {total}</span>
                        <button type="button" aria-label="" className="Polaris-Tag__Button" onClick={clearFilterTag}>
                            <span className="Polaris-Icon">
                                <span className="Polaris-VisuallyHidden"></span>
                                <svg viewBox="0 0 20 20" className="Polaris-Icon__Svg" focusable="false" aria-hidden="true">
                                    <path d="M6.707 5.293a1 1 0 0 0-1.414 1.414l3.293 3.293-3.293 3.293a1 1 0 1 0 1.414 1.414l3.293-3.293 3.293 3.293a1 1 0 0 0 1.414-1.414l-3.293-3.293 3.293-3.293a1 1 0 0 0-1.414-1.414l-3.293 3.293-3.293-3.293z"></path>
                                </svg>
                            </span>
                        </button>
                    </span>
                }
            </div>
            }
            flushFilters
            items={tableData}
            renderItem={(item, index) => {
                const { title, imgsrc, seo_score } = item;
                // primary_keywords
                let id = Number(item.id);
                if (pagetype === 'blog' && item.article_id) {
                    id = Number(item.article_id);
                }
                return (
                    <div id={`${pagetype}_${id}_${index}`} key={`${pagetype}_${id}_${index}`} className={`search_items ${selectId.includes(id) ? 'sitem_active' : ''}`} onClick={() => handleChangeItem(item)}>
                        {
                            pagetype !== 'otherpage' ?
                                <div className='si_img'>
                                    <Thumbnail source={imgsrc || NoteIcon} alt={title} size={'small'} />
                                </div> : null
                        }
                        <div className='si_title'>
                            <span className='ellipsis_2'>{title}</span>
                        </div>
                        <div className='si_score'>
                            <div className="seoissuesTableMaxRow">
                                <CircularViewGauge
                                    value={Math.ceil(((seo_score && seo_score > 100) ? 100 : seo_score) || 0)}
                                    size={60}
                                    strokeWidth={5}
                                    labelSize={13}
                                />
                            </div>
                            {/* {
                                item.is_all_alt === 0 &&
                                <div className='alt_not_set' onClick={(e) => {
                                    e.stopPropagation();
                                    openAltOperaData(item, index)
                                }}>
                                    <Badge>{t("No alt text")}</Badge>
                                </div>
                            } */}
                        </div>
                        {/* {
                            selectId.includes(id) && <div className={`si_active ${pagetype === 'otherpage' ? 'middle_icon' : ''}`}>
                                <Icon source={MobileAcceptMajor} />
                            </div>
                        } */}
                    </div>
                );
            }}
            selectedItems={selectId}
            loading={tableListLoading}
        />
    );

    function disambiguateLabel(key, value) {
        switch (key) {
            case 'Statuses':
                let onpageProductStatusTag = productStatusData.filter(i => value.includes(i.value));
                let onpageProductStatusTagText = '';
                onpageProductStatusTag.forEach((c, i) => {
                    onpageProductStatusTagText += (i === (value.length - 1)) ? `${c.value}` : `${c.value}, `;
                })
                return `${t("Statuses")}: ${onpageProductStatusTagText}`;
            case 'Visibility':
                let blogVisibleTag = blogVisibleData.filter(i => i.value === value[0]);
                let blogVisibleTagText = blogVisibleTag.length > 0 ? blogVisibleTag[0]['label'] : '';
                return `${t("Visibility")}: ${blogVisibleTagText}`;
            case 'issueType':
                let tag = issueListData.filter(i => i.value === value[0]);
                let tagText = tag.length > 0 ? tag[0]['label'] : '';
                return `${t("Tag")}: ${tagText}`;
            case 'seoScore':
                let stag = scoreListData.filter(i => value.includes(i.value));
                let stagText = '';
                stag.forEach((c, i) => {
                    stagText += (i === (value.length - 1)) ? `${c.label}` : `${c.label}, `;
                })
                return `${t("Tag")}: ${stagText}`;
            case 'focusKeyword':
                let fkeytag = focusKeywordListData.filter(i => i.value === value[0]);
                let fkeyText = fkeytag.length > 0 ? fkeytag[0]['label'] : '';
                return `${t("Tag")}: ${fkeyText}`;
            case 'faqSchema':
                let faqTag = faqSchemaChoices.filter(i => i.value === value[0]);
                let faqText = faqTag.length > 0 ? faqTag[0]['label'] : '';
                return `${t("FAQ schema")}: ${faqText}`;
            case 'howtoSchema':
                let howtoTag = howtoSchemaChoices.filter(i => i.value === value[0]);
                let howtoText = howtoTag.length > 0 ? howtoTag[0]['label'] : '';
                return `${t("Howto schema")}: ${howtoText}`;
            case 'productTag':
                const productTags = Array.isArray(value) ? value : [value];
                const maxShow = 2;
                const shownTags = productTags.slice(0, maxShow).join(', ');
                const remaining = productTags.length - maxShow;
                const productTagText = remaining > 0 ? `${shownTags}... +${remaining}` : shownTags;
                return `${t("Product Tag")}: ${productTagText}`;
            default:
                return value;
        }
    }

    function isEmpty(value) {
        if (Array.isArray(value)) {
            return value.length === 0;
        } else {
            return value === '' || value == null;
        }
    }
}

export default SearchFilterList;